import React, { useState } from "react";
import {
  Card,
  Col,
  Row,
  Table,
  Typography,
  Button,
  Popconfirm,
  message
} from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { PAGINATION } from "../../_redux/constant";
import { get } from "lodash";
import { DEFAULT_VALUE } from "../../../app/_redux/constants";
import barrierService from "../../../../../services/BarrierService";
import AddEditGate from "./modals/addEditGate";

const { Text } = Typography;
function Gates({
  total_elements,
  loading,
  dataSource,
  params,
  onChangeParam,
  onClickCreate,
  allStations
}) {
  const CARD_STYLE = {
    borderRadius: "0.42rem",
    boxShadow: "0px 0px 30px 0px rgba(82, 63, 105, 0.05)"
  };
  const CARD_BODY_STYLE = {
    padding: "0px 10px 10px 10px"
  };
  const CARD_HEAD_STYLE = {
    padding: "0px 9px 0px 9px",
    borderBottom: "none"
  };
  const SNoStyle = {
    color: "#14a05b",
    fontWeight: "bold",
    display: "inline-block",
    textAlign: "center"
  };

  const CellAction = ({ record }) => {
    const dispatch = useDispatch();
    const [modal, setModal] = useState({
      visible: false,
      isEdit: true,
      id: null,
      data: null,
      stations: allStations,
      gates: [],
      dvrs: []
    });

    const _handleShowModal = () => {
      setModal(prev => ({
        ...prev,
        visible: !prev.visible,
        isEdit: !prev.visible ? true : false,
        id: record.id,
        data: record,
        stations: allStations,
      }));
    };

    const _handleDeleteCamera = async () => {
      const response = await barrierService.deleteGate(record.id);
      if (response && response.data && response.data.success) {
        message.success(
          get(response, "data.message", "Xóa cổng thành công.")
        );
        onChangeParam({
          page: params.page,
          size: params.size
        });
      } else {
        message.error(get(response, "data.message", "Có lỗi xảy ra."), 5);
      }
    };
    return (
      <Row align="middle" justify="center">
        <Col>
          <Button size="small" type="text" onClick={_handleShowModal}>
            <EditOutlined className="text-primary" />
          </Button>
        </Col>
        <Col>
          <Popconfirm
            cancelText="Quay lại"
            okText="Xác nhận"
            placement="topRight"
            title="Xác nhận xóa cổng?"
            onConfirm={_handleDeleteCamera}
          >
            <Button size="small" type="text">
              <DeleteOutlined className="text-danger" />
            </Button>
          </Popconfirm>
        </Col>
        <AddEditGate
          modal={modal}
          onShowModal={_handleShowModal}
        />
      </Row>
    );
  };

  const columns = [
    {
      dataIndex: "stt",
      title: "STT",
      width: "10%",
      align: "center"
    },
    {
      dataIndex: "station_name",
      title: "Kho",
      width: "30%",
      align: "center",
      key: "station_name",
      render: (station_name, record) => {
        return (
          <Text>
            <span style={SNoStyle}>{get(record, "station_id", "-")}</span>
            {station_name ? " | " + station_name : " | " + DEFAULT_VALUE}
          </Text>
        );
      }
    },
    {
      dataIndex: "gate_name",
      key: "gate_name",
      title: "Tên cổng",
      width: "20%",
      align: "center",
      render: value => value || DEFAULT_VALUE
    },
    {
      dataIndex: "gate_id",
      key: "gate_id",
      title: "ID cổng",
      width: "20%",
      align: "center",
      render: value => value || DEFAULT_VALUE
    },
    {
      dataIndex: "action",
      title: "Hành động",
      width: "20%",
      render: (text, record) => <CellAction record={record} />,
      align: "center"
    }
  ];

  const renderCardExtra = () => {
    return (
      <div className="d-flex aligns-items-center">
        <Button onClick={onClickCreate} type="primary">
          Thêm mới
        </Button>
      </div>
    );
  };

  return (
    <Card
      className="log__container"
      size="small"
      style={CARD_STYLE}
      bodyStyle={CARD_BODY_STYLE}
      headStyle={CARD_HEAD_STYLE}
      title={
        <Row align="middle" gutter={[8]} justify="start">
          <Col>
            <Text>
              Tổng số cổng:{" "}
              <Text className="text-dark">{total_elements}</Text>
            </Text>
          </Col>
        </Row>
      }
      extra={renderCardExtra()}
    >
      <Table
        loading={{
          spinning: loading,
          delay: 500
        }}
        rowKey="id"
        size="large"
        bordered
        columns={columns}
        dataSource={dataSource}
        pagination={{
          pageSize: params.size,
          current: params.page,
          defaultPageSize: PAGINATION.gate.page,
          total: total_elements,
          showSizeChanger: true,
          onChange: (page, pageSize) => {
            onChangeParam({
              page: page,
              size: pageSize
            });
          }
        }}
      />
    </Card>
  );
}

export default React.memo(Gates);
